<template>
  <modal @open="loadArtists()" class="following-modal" :show.sync="$parent.modals.followingModal" modalContentClasses="following-modal-content" bodyClasses="following-modal-body">
    <h6 slot="header" class="modal-title" id="modal-title-default">
      Following ({{this.user.following.length}})
      <small
        class="mt-2 d-block"
      >Manage the artists you're following here.</small>
    </h6>
    <div class="following-scroll-wrapper">
      <div v-for="artist in followingArtists" class="following-wrapper" v-bind:key="artist.artist_id">
        <div class="d-flex align-items-center following-name">
          <img :src="artist.profile_image" class="following-avatar rounded-circle" :alt="artist.handle + ' avatar'" />
          <div class="following-name ml-1">{{artist.handle}}</div>
        </div>
        <div><follow-button :artist_id="artist.artist_id" /></div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapState } from "vuex";
import FollowButton from "../components/FollowButton.vue";

export default {
  name: "following-modal",
  data() {
    return {
      loading: false,
      followingArtists: []
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  components: {
    FollowButton
  },
  mounted() {
    this.loadArtists();
  },
  methods: {
    loadArtists() {
      this.followingArtists = this.user.following;
    }
  }
};
</script>

<style lang="scss">
  .following-modal-content {
    max-height: calc(100vh - 200px);
    overflow: hidden;

    .following-scroll-wrapper {
      overflow-y: scroll;
    }

    .following-wrapper {
      margin-bottom: 1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .following-name {
        font-weight: bold;
        font-size: .875rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .following-avatar {
        height: 40px;
        width: 40px;
      }
    }
  }
  .following-modal-body {
    overflow-y: scroll;
  }
</style>
